import styled from '../../../config/theme'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const ModalContent = styled.div`
  padding: 20px;
`

export {
  Container,
  ModalContent,
}
